module.exports = {"370117001":"艾山街道","370117002":"里辛街道","370117003":"汶源街道","370117004":"颜庄街道","370117005":"辛庄街道","370117400":"棋山国家森林公园","370117401":"高新技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370117.json
// module id = 1475
// module chunks = 0